import {
  Component,
  ViewEncapsulation,
  Output,
  EventEmitter,
  Input,
  OnInit,
  HostListener,
} from "@angular/core";
import { ButtonType } from "../../../models/buttons/ButtonType";
import { ButtonInterface } from "src/app/models/buttons/ButtonInterface";
import { ActionsEnum } from "src/app/models/ActionsEnum";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ButtonComponent implements OnInit {
  @Output()
  public onClick: EventEmitter<any>;

  @Input() item: ButtonInterface;

  assetUrl = "assets/images/";
  public innerWidth: any;

  constructor() {
    this.onClick = new EventEmitter();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    // if (
    //   // this.item.getButton().getType() === ButtonType.COLOR &&
    //   this.item.getButton().getByDefault() &&
    //   this.item.getParentMenuItem() &&
    //   this.item.getParentMenuItem().getItems() &&
    //   this.item
    //     .getParentMenuItem()
    //     .getItems()
    //     .every((each) => !each.isClicked())
    // ) {
    //   this.item.setClicked(true);
    // }
  }

  clickOnMe() {
    //Si es un botón con ícono, cambio de ícono
    if (this.item.getType() === ButtonType.ICON) {
      this.item.toogleIcon();
    }

    //   //Si se hace click en el button de vistas tengo que cambiar la imagen
    //   if (this.item.getType() === ActionsEnum.CHANGE_VIEW_ALLOWED) {
    //     this.item.changeCurrentIcon();
    //     // if (this.iconName === this.item.getButton().getIcon()) {
    //     //   this.iconName = this.item.getButton().getAlternativeIcon();
    //     // } else {
    //     //   this.iconName = this.item.getButton().getIcon();
    //     // }
    //   }

    //   if (
    //     this.item.getType() === ActionsEnum.CHANGE_OBJECT &&
    //     this.item.getParentMenuItem() &&
    //     this.item.getParentMenuItem().getButton()
    //   ) {
    //     this.item
    //       .getParentMenuItem()
    //       .getButton()
    //       .setIcon(this.item.getButton().getIcon());
    //   }

    this.onClick.emit();
  }

  get buttonType() {
    return ButtonType;
  }
}
